import { isEmpty } from 'lodash';

import { TCustomerField } from 'modules/checkout/domain/entities';
import { ICustomer } from 'shared/domain/entities';

import needsGuardianValidation from './needsGuardianValidation';

export default function isCustomerRegistrationIncomplete(
  customer: ICustomer | null,
  missingFields: TCustomerField[],
  confirmedGuardianDocument: string | null = null,
) {
  if (!customer) return false;

  // A validação do responsável fica fora da lista do Vectis de propósito: ela não é um dado que
  // falta no cadastro, e sim uma confirmação que o site exige de quem acompanha o menor. O
  // Vectis não a conhece — sem esta linha, o menor com responsável não validado passaria direto.
  return (
    !isEmpty(missingFields) ||
    needsGuardianValidation(customer, confirmedGuardianDocument)
  );
}
